import { render, staticRenderFns } from "./UploadFileCard.vue?vue&type=template&id=7c6756a5&scoped=true&"
import script from "./UploadFileCard.vue?vue&type=script&lang=js&"
export * from "./UploadFileCard.vue?vue&type=script&lang=js&"
import style0 from "./UploadFileCard.vue?vue&type=style&index=0&id=7c6756a5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6756a5",
  null
  
)

export default component.exports